<template>
    <a-modal
      wrapClassName="customModal"
      v-model="showDelDialog"
      title="关联二维码"
      centered
      :width="400"
      destroyOnClose
      :maskClosable="false"
      @ok="handleBind"
      @cancel="afterClose"
    >
      <div class="qrCode-dialog-body">
            <a-input
              v-model="bindQrData.bindQrCode"
              placeholder="输入教室二维码编号"
              :disabled="isShowQrInput"
            >
            </a-input>
            <div class="err-txt">{{ errTxt ? errTxt : '' }}</div>
      </div>
    </a-modal>
    
</template>

<script>
export default {
    props: {
        showBindQrDialogProp: {
            type: Boolean,
            default: false
        },
        bindQrData: {
            type: Object
        },
        isShowQrInput: {
            type: Boolean
        },
        errTxt: {
            type: String
        }
    },
    watch: {
        showBindQrDialogProp(val, old) {
            this.showDelDialog = val
            if (val == true) {
            }
        }
    },
    data() {
        return {
            showDelDialog: false,
        }
    },
    methods: {
        afterClose() {
            // this.$emit("update:showBindQrDialogProp", false)
            this.$emit("handleCancelBindQr")  
        },
        handleBind() {
            this.$emit("handleBindQr", this.bindQrData)
        }
    }
}
</script>

<style lang="scss" scoped>
.err-txt{
    padding-left: 4px;
    color: #F0483B;
    margin-top: 10px;
}
::v-deep .ant-modal-body {
    padding: 24px 16px !important;
    min-height: 100px;
    border-bottom: 1px solid #e7e7e7;
}
::v-deep .ant-modal-footer {
    padding: 20px;
    border-top: none;
    text-align: center;
    .ant-btn {
        width: 108px;
        height: 38px;
        border: 1px solid #5F60D3;
        color: #5F60D3;
    }
    .ant-btn-primary {
        margin-left: 16px;
        background: #5F60D3;
        color: #fff;
    }
}
</style>